import React from 'react';
import { Typography } from '@material-ui/core';

import { Box } from 'components';
import { ComingSoonImg } from 'assets';

import styles from './styles';

const ComingSoon = () => {
  const classes = styles();

  return (
    <Box>
      <Box className={classes.comingSoonContentBox}>
        <Typography variant="body1" className={classes.comingSoonHeaderText}>
          This page is under construction{' '}
        </Typography>
        {/* <Typography variant="body1" className={classes.comingSoonSubHeaderText}>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the{' '}
        </Typography> */}
        <img
          src={ComingSoonImg}
          alt={ComingSoonImg}
          className={classes.comingSoonImage}
        />
        <Typography variant="h3" className={classes.comingSoonText}>
          Coming Soon...!
        </Typography>
      </Box>
    </Box>
  );
};
export default ComingSoon;
